export const colors = {
  white: "#FFFFFF",
  bg_dark: "#FAFBFF",
  blue_light: "#0490FE",
  warninng: "rgb(254,211,58)",
  success: "rgb(60,213,97)",
  color_primary: "#6B5CA8",
  color_primary_dark: "#384364",
  lightPurple: "#7E67D6",
  bg_light: "#FAFBFF",
  dark_grey: "#888EA2",
  light_grey: "#CFD2D8",
  primary_dark_bg:"rgba(207,210,216,0.46)",

  danger:"rgb(255,93,132)"
};
